export interface Design {
  rounding: Rounding,
  borderWidth: BorderWidth,
  theme: Theme,
}

export interface Rounding {
  box: string;
  checkbox: string;
  invisibleHint: string;
}

export interface BorderWidth {
  box: string;
  checkbox: string;
}

export interface Theme {
  light: Colors,
  dark: Colors,
}

export interface Colors {
  boxDefaultBackground: string;
  boxDefaultText: string;
  boxDefaultBorder: string;
  boxCheckboxBackground: string;
  boxCheckboxBorder: string;
  boxSuccessBackground: string;
  boxSuccessBorder: string;
  boxFailureBackground: string;
  boxFailureBorder: string;
  boxFailureText: string;
  invisibleHintBackground: string;
  spinnerColor: string;
  successIconColor: string;
}

export const defaultDesign: Design = {
  rounding: {
    box: '6px',
    checkbox: '8px',
    invisibleHint: '6px',
  },
  borderWidth: {
    box: '1px',
    checkbox: '1px',
  },
  theme: {
    light: {
      boxDefaultBackground: '#f9fafb',     // tailwind gray-50
      boxDefaultText: '#374151',           // tailwind gray-700
      boxDefaultBorder: '#e5e7eb',         // tailwind gray-200
      boxCheckboxBackground: '#ffffff',    // tailwind white
      boxCheckboxBorder: '#888f9c',        // between tailwind gray-400 and gray-500
      boxSuccessBackground: '#f9fafb',     // tailwind gray-50
      boxSuccessBorder: '#16a34a',         // tailwind green-600
      boxFailureBackground: '#fef2f2',     // tailwind red-50
      boxFailureBorder: '#ef4444',         // tailwind red-500
      boxFailureText: '#7f1d1d',           // tailwind red-900
      invisibleHintBackground: '#ffffff',  // tailwind white
      spinnerColor: '#3b82f6',             // tailwind blue-500
      successIconColor: '#16a34a',         // tailwind green-600
    },
    dark: {
      boxDefaultBackground: '#1f2937',     // tailwind gray-800
      boxDefaultText: '#e5e7eb',           // tailwind gray-200
      boxDefaultBorder: '#374151',         // tailwind gray-700
      boxCheckboxBackground: '#030712',    // tailwind gray-950
      boxCheckboxBorder: '#6b7280',        // tailwind gray-500
      boxSuccessBackground: '#1f2937',     // tailwind gray-800
      boxSuccessBorder: '#22c55e',         // tailwind green-500
      boxFailureBackground: '#450a0a',     // tailwind red-950
      boxFailureBorder: '#ef4444',         // tailwind red-500
      boxFailureText: '#fecaca',           // tailwind red-200
      invisibleHintBackground: '#1f2937',  // tailwind gray-800
      spinnerColor: '#3b82f6',             // tailwind blue-500
      successIconColor: '#22c55e',         // tailwind green-500
    },
  },
};

export function mergeDesign(custom: Partial<Design>): Design {
  return mergeDeep(JSON.parse(JSON.stringify(defaultDesign)), custom);
}

function mergeDeep(target: any, source: any): any {
  for (const key in source) {
    const value = source[key];
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      target[key] = mergeDeep(target[key] ?? {}, value);
    } else if (value !== undefined) {
      target[key] = value;
    }
  }
  return target;
}
